export interface WalletInfoProps {
  is_id_verify: boolean;
  is_phone_verify: boolean;
  pay_pwd: boolean;
  credit_score: number;
  balance: number;
  realName: string;
  phone?: string;
}

/** 与 App / proto PaymentMethod 对齐：0 银行卡 1 支付宝 2 微信 */
export enum EPayType {
  BANK = 0,
  ALIPAY = 1,
  WECHAT = 2,
}

export const payTypeLabel = (t?: number) => {
  if (t === EPayType.BANK) return "银行卡";
  if (t === EPayType.ALIPAY) return "支付宝";
  if (t === EPayType.WECHAT) return "微信";
  return "未知";
};

export const payTypeImage = (t?: number) => {
  switch (t) {
    case EPayType.BANK:
      return require("../../assets/images/wallet/bank.png");
    case EPayType.ALIPAY:
      return require("../../assets/images/wallet/alipay.png");
    case EPayType.WECHAT:
      return require("../../assets/images/wallet/wechat.png");
    default:
      return require("../../assets/images/wallet/bank.png");
  }
};
